import { subDays, format, getDaysInMonth } from 'date-fns'
import availableJobCategories from '@/helpers/availableJobCategoriesHelper'

export default function() {
    return {
        profiles: [],
        fields: [
            {
                key: 'name',
                label: 'Nome'
            },
            {
                key: 'category',
                label: 'Categoria'
            },
            {
                key: 'createdAt',
                label: 'Data de cadastro'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ],
        availableJobCategories: [
            {
                label: 'Todas',
                code: null
            },
            ...availableJobCategories
        ],
        itemsPerPage: 15,
        totalPages: 0,
        currentPage: 1,
        'order[createdAt]': 'DESC',
        filters: {
            'month[after]': format(subDays(new Date().setDate(1), 180), 'yyyy-MM-dd'),
            'month[before]': format(new Date().setDate(getDaysInMonth(new Date())), 'yyyy-MM-dd'),
            'createdAt[after]': null,
            'createdAt[before]': null,
            category: null
        },
        charts: {
            bars_restaurants: {
                months: {},
                total: 0,
                label: 'Bares e Restaurantes',
                color: 'info'
            },
            casting: {
                months: {},
                total: 0,
                label: 'Casting',
                color: 'warning'
            },
            event_support: {
                months: {},
                total: 0,
                label: 'Suporte para Eventos',
                color: 'danger'
            },
            master_of_ceremonies: {
                months: {},
                total: 0,
                label: 'Mestres de Cerimônias',
                color: 'success'
            }
        }
    }
}
